
















import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator'

@Component({ name: 'CRUD' })
export default class CRUD extends Vue {
  @Prop() crud!: string
  @Prop() label!: string
  @Prop() disabled!: boolean

  selected = [] as Array<string>

  @Watch('selected')
  onSelected () {
    let res = ''
    this.selected.forEach(s => {
      res += s
    })
    this.update(res)
  }

  @Watch('crud')
  onCRUD () {
    // this.selected.splice(0, this.selected.length)
    this.selected = this.crud.split('')
  }

  @Emit('update:crud')
  update (val: string) {
    return val
  }

  mounted () {
    this.selected = this.crud.split('')
  }
}
